<template src="@/components/collections/templates/PaymentTemplate.html">
</template>
<script type="text/javascript">
import { mapGetters } from "vuex"
import PaymentMixin from "@/mixins/payment-mixin"
import FinalReviewMixin from "@/mixins/final-review-mixin"
import CartFixed from "@/components/modules/hosted-pages/CartFixed"
import PaymentComponent from "@/components/modules/hosted-pages/PaymentComponent"
import ManagePaymentMethod from "@/components/modules/hosted-pages/ManagePaymentMethod"
import CBNotification from "@/models/cb-notification"
import Notes from "@/components/collections/elements/Notes"
import LazyLoadPaymentComponents from '@/components/modules/hosted-pages/LazyLoadPaymentComponents'
export default {
  mounted(){
    if(this.canShowPaymentMethodPicker()) {
      this.payment_method_type = undefined;
      return;
    }
    if(this.get_form_temp('pm_type')) {
      this.payment_method_type = this.get_form_temp('pm_type');
      this.$store.dispatch('delete_form_temp',  'pm_type');
    } else {
      this.payment_method_type = this.editMode && this.selected_payment_method && this.isPmAvailableInList(this.selected_payment_method) ? this.selected_payment_method.type : this.pm_list_filtered[0] && this.pm_list_filtered[0].type;
      if(!this.payment_method_type) {
        this.$store.dispatch('set_current_notification', new CBNotification('error', {message: this.st('gateway_error')}));
      }
    }
  },
  mixins: [PaymentMixin, FinalReviewMixin],
  computed: {
    ...mapGetters([
      'skip_cart',
      "canAddNewPaymentMethod",
      'current_error_source',
      'pm_authorized',
      'is_checkout_existing',
      'is_checkout_one_time',
      'hasTrialPeriod',
      'plan_placeholder',
      'selected_payment_method',
      'get_form_temp',
      'one_screen_checkout',
      'pm_list_filtered'
    ]),
    buttonTxt() {
      if (this.$route.query.mode == "empty") {
        return this.$store.getters.translate(`${this.$route.name}.update`)
      }
      return this.editMode ? this.$store.getters.translate(`${this.$route.name}.update`) : this.$store.getters.translate(`${this.$route.name}.next`);
    },
    useBillingInfo() {
      return this.$store.getters.field_config("card", "card.copy_billing_info") && this.$store.getters.field_config("card", "card.copy_billing_info").value;
    },

    useShippingInfo() {
      return this.$store.getters.field_config("card", "card.copy_shipping_info") && this.$store.getters.field_config("card", "card.copy_shipping_info").value;
    },

    paymentNote() {
      if(this.hasTrialPeriod){
        return this.t('payment_method.note.plan.trial', this.plan_placeholder);
      }
      return this.t('payment_method.note.plan.no_trial', this.plan_placeholder);
    },
    threedsNote() {
      if(this.one_screen_checkout) {
        return this.hasTrialPeriod ? this.t('review.threedsWarning.trial') : this.t('review.threedsWarning.non_trial');
      }
    },
    additional_info(){
      return this.pm && this.pm.configuration && this.pm.configuration.additional_info;
    },
    paymentDescriptorNote() {
      return (
        this.additional_info &&
        this.additional_info.payment_descriptor
      );
    },
    paymentCancellationNote() {
      return (
        this.additional_info &&
        this.additional_info.payment_cancellation
      );
    },
    canShowMandateText() {
      return this.$store.getters.pm_by_mandate_enabled && this.pm.gateway_name == 'STRIPE';
    },
    eMandateTxt() {
      return 'For cards issued in India, an e-mandate will be set up to automate recurring payments for this subscription. The mandate specifies broad terms so variations in the recurring charge (amount or frequency) do not require your manual confirmation. You will only be charged according to the plan you subscribe to.'
    }
  },
  data() {
    return {
      payment_method_type: undefined,
      showLoader: false,
      swapPaymentMethod : true,
      retain_card: false,
      replace_primary_pm: false,
    }
  },
  props: ['editMode', 'subscribeMode'],
  methods: {
    submit() {
      this.managePaymentSource();
      this.validateAndProceed();
    },

    updatePmOption(data) {
      if(!data) return;  
      if(data.hasOwnProperty('replace_primary_pm')) 
        this.replace_primary_pm = data.replace_primary_pm;
      if(data.hasOwnProperty('retain_card')) 
        this.retain_card = data.retain_card;
    },
    managePaymentSource() {
      if (!this.is_checkout_one_time) return;
      switch (this.$store.getters.retain_pm_option) {
        case "NEVER":
          this.replace_primary_pm = false;
          this.retain_card = false;
          this.$store.dispatch("set_replace_pm", this.replace_primary_pm);
          this.$store.dispatch("set_retain_pm", this.retain_card);
          break;
        case "ALWAYS":
          this.replace_primary_pm = this.canAddNewPaymentMethod ? false : true; 
          this.retain_card = true;
          this.$store.dispatch("set_replace_pm", this.replace_primary_pm);
          this.$store.dispatch("set_retain_pm", this.retain_card);
          break;
        case "ASK_CUSTOMER":
          this.retain_card = this.replace_primary_pm ? true : this.retain_card
          this.$store.dispatch("set_replace_pm", this.replace_primary_pm);
          this.$store.dispatch("set_retain_pm", this.retain_card);
          break;
      }
    },
    proceed(data) {
      (this.subscribeMode
        ? this.addPaymentMethod().then(() => this._submit())
        : this.submitForCheckout(data)).catch((error) => {
            logger.e(error);
        });
    },
    setPaymentType($event){
      this.$store.dispatch('set_pm_consent', true);
      this.payment_method_type = $event;
    },
    _displayErrorMessage() {
      let error = this.current_error_source;
      if(!this.current_error_source) {
        return;
      }
      if(error.isParamException && error.isParamException()){
        if(this.payment_method_type == "card") {
          this.$store.dispatch('set_error', {name: error.paramName, fname: "card",
            error: error.paramMessage
          });
        }
      }
    },
    isPmAvailableInList(selected_payment_method) {
      return this.pm_list_filtered.some(pm => pm.type == selected_payment_method.type)
    }
  },
  components: {
    'card-section': LazyLoadPaymentComponents.CheckoutCardSection,
    'paypal-section': LazyLoadPaymentComponents.PaypalSection,
    'direct-debit-section': LazyLoadPaymentComponents.DirectDebitSection,
    'amazon-payment-section':  LazyLoadPaymentComponents.AmazonPaymentSection,
    'apple-pay-section': LazyLoadPaymentComponents.ApplePaySection,
    'cart-fixed': CartFixed,
    'payment-component' : PaymentComponent,
    'manage-payment-component' : ManagePaymentMethod,
    'cb-notes': Notes,
    'ideal-section': LazyLoadPaymentComponents.iDealSection,
    'sofort-section': LazyLoadPaymentComponents.SofortSection,
    'bancontact-section': LazyLoadPaymentComponents.BancontactSection,
    'google-pay-section': LazyLoadPaymentComponents.GooglePaySection,
    'giropay-section': LazyLoadPaymentComponents.GiropaySection,
    'offline-payment-section': LazyLoadPaymentComponents.OfflinePaymentSection,
    'netbanking-section': LazyLoadPaymentComponents.NetbankingSection,
    'upi-section': LazyLoadPaymentComponents.UpiSection,
    'boleto-section': LazyLoadPaymentComponents.BoletoSection,
    'venmo-section': LazyLoadPaymentComponents.VenmoSection,
  }
}
</script>
